import { connect } from 'react-redux';

import AggregateCheckBoxView from '../../components/users/AggregateCheckBox';
import { aggregateUsers } from '../../actions/users';
import { isUsersAggregateEnabled } from '../../reducers/analyticsApp';

const mapStateToProps = (state) => ({
  cacheEnabled: isUsersAggregateEnabled(state),
});

const mapDispatchToProps = {
  onChange: aggregateUsers,
};

const AggregateCheckBox = connect(mapStateToProps, mapDispatchToProps)(AggregateCheckBoxView);

export default AggregateCheckBox;
